"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryCard = exports.MainTop = exports.MainBottom = void 0;
exports.ProductMarqueeDual = ProductMarqueeDual;
exports.default = exports.SecondaryPaddedWrapper = exports.SecondaryCard = exports.ProductMarqueeDualSection = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/card/index.js"));
var _attributionBlock = _interopRequireDefault(require("@site/pattern-library-core/attribution-block"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _smartTestimonialsCard = _interopRequireDefault(require("../../../page-body/sections/smart-testimonials-section/smart-testimonials-card"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
const ProductMarqueeDualSection = exports.ProductMarqueeDualSection = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ProductMarqueeDualSection",
  class: "pl-p1nohvcs",
  vars: {
    "p1nohvcs-2": [({
      backgroundColor
    }) => backgroundColor ?? `${_intents.default.ux.box.backgroundColor}`],
    "p1nohvcs-4": [({
      desktop
    }) => desktop ? `url(${desktop})` : 'initial']
  }
});
const PrimaryCard = exports.PrimaryCard = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryCard",
  class: "pl-ph5h525",
  vars: {
    "ph5h525-0": [({
      mobile
    }) => mobile ? `url(${mobile})` : 'initial'],
    "ph5h525-2": [({
      hasMobileImage
    }) => hasMobileImage ? '65vh' : 'unset'],
    "ph5h525-3": [({
      backgroundColor
    }) => backgroundColor ?? `${_intents.default.ux.box.backgroundColor}`],
    "ph5h525-7": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial']
  }
});
const MainTop = exports.MainTop = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MainTop",
  class: "pl-mdg7bo5",
  vars: {
    "mdg7bo5-0": [({
      align = 'start'
    }) => align]
  }
});
const MainBottom = exports.MainBottom = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MainBottom",
  class: "pl-m1bz9m1j"
});
const SecondaryCard = exports.SecondaryCard = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SecondaryCard",
  class: "pl-s17l0ilf"
});
const SecondaryPaddedWrapper = exports.SecondaryPaddedWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SecondaryPaddedWrapper",
  class: "pl-s1beh8n0"
});

/**
 * Render product marquee.
 *
 * @param {object} props React props
 * @param {string} props.marqueeLayout Marquee layout types
 * @param {React.ReactElement} props.card Primary Card definition (required)
 * @param {object} props.secondaryCard Secondary Card json object(optional)
 * @param {string} props.attributionName Attribution name  (optional)
 * @param {string} props.attributionUrl Attribution url (optional)
 * @param {object} props.backgroundImages Object of background images for all breakpoints.
 * @param {String} props.partial Theme partial
 * @param {object} props.priceLockup Price Lockup
 * @param {string} props.attributionHeadline Attribution Headline (optional)
 * @param {string} props.attributionDescription Attribution Description (optional)
 * @returns {React.ReactElement} Full Marqueecomponent
 * @public
 */
// eslint-disable-next-line complexity
function ProductMarqueeDual({
  invert,
  partial,
  marqueeLayout,
  backgroundImages,
  backgroundColor,
  attributionName,
  attributionUrl,
  secondaryCard,
  countdownClock,
  card,
  priceLockup,
  attributionHeadline,
  attributionDescription,
  ...cardProps
}) {
  let secondaryCardItem;
  switch (marqueeLayout) {
    case 'list':
      secondaryCardItem = /*#__PURE__*/_react.default.createElement(SecondaryPaddedWrapper, null, /*#__PURE__*/_react.default.isValidElement(secondaryCard) ? secondaryCard : /*#__PURE__*/_react.default.createElement(_list.default, secondaryCard));
      break;
    case 'testimonial':
      secondaryCardItem = /*#__PURE__*/_react.default.isValidElement(secondaryCard) ? secondaryCard : /*#__PURE__*/_react.default.createElement(_smartTestimonialsCard.default, (0, _extends2.default)({
        embedded: true
      }, secondaryCard));
      break;
    default:
    case 'text-lockup':
      {
        const ctasNormalized = (secondaryCard?.props?.ctas || secondaryCard.ctas) && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
          buttons: secondaryCard?.props?.ctas || secondaryCard.ctas
        });
        const secondaryCardNormalized = {
          ...(secondaryCard?.props || secondaryCard),
          ctas: ctasNormalized
        };
        secondaryCardItem = /*#__PURE__*/_react.default.createElement(SecondaryPaddedWrapper, null, /*#__PURE__*/_react.default.isValidElement(secondaryCard) ? (/*#__PURE__*/_react.default.cloneElement(secondaryCard, {
          padding: 'none',
          headlineSize: 'h5',
          indented: true,
          textAlign: 'start',
          ...secondaryCardNormalized
        })) : /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
          padding: "none",
          headlineSize: "h5",
          indented: true,
          textAlign: "start"
        }, secondaryCardNormalized)));
        break;
      }
  }
  const {
    mobile
  } = backgroundImages;
  const hasAttribute = attributionName?.length > 0 || attributionUrl?.length > 0;
  const secondaryCardProps = secondaryCard?.props || secondaryCard;
  return /*#__PURE__*/_react.default.createElement(ProductMarqueeDualSection, (0, _extends2.default)({
    className: "legacy-container",
    "data-cy": "product-marquee-dual",
    "data-partial": partial || (invert ? 'dark1' : ''),
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, cardProps, backgroundImages), /*#__PURE__*/_react.default.createElement(PrimaryCard, (0, _extends2.default)({
    "data-cy": "primary-card",
    "data-partial": partial || (invert ? 'dark1' : ''),
    hasMobileImage: mobile?.length > 0,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, backgroundImages), /*#__PURE__*/_react.default.createElement(MainTop, {
    "data-cy": "main-top",
    align: card?.props?.textAlign || cardProps?.textAlign
  }, card && /*#__PURE__*/_react.default.isValidElement(card) ? (/*#__PURE__*/_react.default.cloneElement(card, {
    padding: 'none',
    indented: true,
    textAlign: 'start',
    ctas: cardProps.ctas,
    priceLockup: priceLockup,
    ...card.props
  })) : /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    padding: "none",
    indented: true,
    textAlign: "start"
  }, cardProps, card, {
    priceLockup: priceLockup
  })), countdownClock), (hasAttribute || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(MainBottom, {
    "data-cy": "main-bottom"
  }, /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isBasic: true,
    hideOnMobile: true,
    attributionPosition: "bottom-left",
    tabletAttributionPosition: "bottom-left",
    attribution: attributionName || attributionHeadline
  }), attributionDescription && /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isBasic: true,
    hideOnMobile: true,
    attributionPosition: "bottom-left",
    tabletAttributionPosition: "bottom-left",
    attribution: attributionDescription
  }))), /*#__PURE__*/_react.default.createElement(SecondaryCard, {
    "data-cy": "secondary-card",
    "data-partial": secondaryCardProps?.partial || (secondaryCardProps?.invert ? 'dark1' : '')
  }, secondaryCardItem));
}
ProductMarqueeDual.propTypes = {
  backgroundImages: _propTypes.default.shape({
    mobile: _propTypes.default.string,
    tablet: _propTypes.default.string,
    desktop: _propTypes.default.string
  }),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  attributionName: _propTypes.default.string,
  attributionUrl: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  secondaryCard: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]).isRequired,
  cardProps: _propTypes.default.shape({
    ..._index.default.propTypes
  }),
  card: _propTypes.default.node,
  marqueeLayout: _propTypes.default.oneOf(['list', 'testimonial', 'text-lockup']).isRequired,
  priceLockup: _propTypes.default.object,
  countdownClock: _propTypes.default.node,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string
};
var _default = exports.default = ProductMarqueeDual;